import React from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { createStructuredSelector, createSelector } from 'reselect'
import { firebaseConnect, populate } from 'react-redux-firebase'

import { userIsAuthenticated } from '../behaviors'

const Purchase = ({ children, ...props }) => React.cloneElement(children, props)

const populates = {
  purchases: [
    { child: 'tranche', root: 'tranches' },
    { child: 'payments', root: 'payments' },
  ],
}

const watches = props => [
  {
    path: `/purchases/${props.params.purchaseId}`,
    populates: populates.purchases,
  },
]

const selectors = createStructuredSelector({
  auth: ({ firebase }) => firebase.auth,
  purchase: createSelector(
    (state, { params }) => params.purchaseId,
    ({ firebase }) =>
      populate(firebase, 'purchases', populates.purchases) || {},
    (purchaseId, purchases) => purchases[purchaseId]
  ),
})

export default compose(
  firebaseConnect(watches),
  connect(selectors),
  userIsAuthenticated()
)(Purchase)



// WEBPACK FOOTER //
// ./src/screens/Purchase.js